import ReactPaginate from "react-paginate";
import "./pagination.css";

export default function PaginatedItems({ itemsPerPage, total, setpage })
{
    const pageCount = Math.ceil(total / itemsPerPage) || 0;

    return (
        <ReactPaginate
            breakLabel="..."
            nextLabel=" >>"
            onPageChange={ (e) => setpage(e.selected + 1) }
            pageRangeDisplayed={ 5 }
            pageCount={ pageCount }
            previousLabel="<< "
            renderOnZeroPageCount={ null }
            containerClassName="custom-pagination d-flex align-items-center justify-content-end"
            pageLinkClassName="pagination-tag-anchor mx-1 rounded-circle"
            activeLinkClassName="pagination-tag-anchor--active"
        />
    );
}
